export function globalserverMessage(state = {}, action) {
  switch (action.type) {
    case "SERVER_ERROR":
      return Object.assign({}, state, {
        ErrorMessage: action.data
      });
    case "SERVER_SUCCESS":
      return Object.assign({}, state, {
        SuccessMessage: action.data
      });
    case "CLEAR_ERROR":
      return Object.assign({}, state, {});
    default:
      return {};
  }
}



// WEBPACK FOOTER //
// ./src/modules/serverMessage/reducer.js